import * as Yup from 'yup';

export const typeListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
